import React from "react";
import { BRAND } from "../config/brand";

const RoadMapSection = () => {
  const roadmapSteps = [
    {
      title: "2023",
      points: [
        "Reserve Alexandrite",
        "Alexandrite Appraisal Report",
        "Asset secured in vault under SKR",
      ],
    },
    {
      title: "2024",
      points: [
        `Conceptualization of ${BRAND.tokenSymbol} token`,
        "Whitepaper Drafting",
        "Early business development and regulatory consultations",
        "Brand development and website launch",
      ],
    },
    {
      title: "2025",
      points: [
        "Community building and initial outreach",
        "MVP (Minimal Viable Product) architecture",
        "Smart contract framework design begins",
        "Partnership groundwork (crypto projects, vault security, etc.)",
      ],
    },
    {
      title: "Q1 2026",
      points: [
        `Completion of ${BRAND.tokenSymbol} smart contract`,
        "Smart Contract Audit",
        "Strategic expansion planning",
      ],
    },
    {
      title: "Q2 2026",
      points: [
        "Token Launch",
        "Registration on Centralized Exchanges (CEX)",
        "Provide Liquidity on Decentralized Exchanges (DEX)",
        "Airdrop to community",
        "Listing on CoinMarketCap (CMC)",
        "Implementation of Staking and DeFi Solutions",
      ],
    },
    {
      title: "Q3 2026",
      points: [
        `Launch of ecosystem products accepting ${BRAND.tokenSymbol}`,
        "Expanded partnership integrations",
        `${BRAND.tokenSymbol} recognized as a payment method in new platforms`,
      ],
    },
  ];

  return (
    <div className="roadMapPage">
      <div className="horizontal-roadmap">
        <h2 className="title">Roadmap</h2>
        <div className="roadmap-track">
          <div className="center-line" />
          {roadmapSteps.map((step, index) => (
            <div
              key={index}
              className={`roadmap-step ${index % 2 === 0 ? "left" : "right"}`}
            >
              {/* This is the dot on the center line */}
              <div className="connector-dot" />

              <div className="step-label"> {step.title}</div>
              <div className="content">
                <ul>
                  {step.points.map((point, idx) => (
                    <li key={idx}>{point}</li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default RoadMapSection;
